import { combineReducers } from 'redux';
import orgImport from '../OrgImport/reducers/';
export default combineReducers({
  orgImport,
});



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/CompanyAdmin/reducers/index.js
 **/